import { AbstractModel } from '@/models/abstractModel';
import { BetSelection } from '@/constants';

export abstract class AbstractMarket extends AbstractModel {
    public highlightClassIndex: Record<number, number> = markRaw({});
    public previousPrices: Record<number, string | null> = {};

    public getHighlightClass(betSelection: BetSelection, price: string): string {
        //console.log('getHighlightClass execute for BetSelection #' + betSelection);
        const hlClassIndex = (this.highlightClassIndex[betSelection] ?? 2) === 2 ? 1 : 2;
        this.highlightClassIndex[betSelection] = hlClassIndex;
        const previousPrice = this.previousPrices[betSelection];

        if (previousPrice !== null) {
            if (price > previousPrice) {
                return `highlightGreen${hlClassIndex}`;
            } else if (price < previousPrice) {
                return `highlightRed${hlClassIndex}`;
            }
        }

        return '';
    }

    public setPreviousPrice(betSelection: BetSelection, price: string | null): void {
        this.previousPrices[betSelection] = price;
    }
}
